import './GlobalStyle.scss'
import {ReactChild, ReactChildren} from 'react'

interface Aux {
    children: ReactChild| ReactChildren}

export const GlobalStyle = ({children}: Aux) => {
return <>{children}</>
}